import { css } from '@emotion/css';
import { maxTextLines } from 'Shared/frontend/Poster';
import { fonts, poster } from 'Shared/frontend/SettingsProvider';

export const eventNameStyle = () => css(poster('separated').name, {
	fontFamily: fonts().text,
	lineHeight: '1.2em',
	textTransform: 'uppercase',
	width: '100%',
	fontSize: '0.9em',
	minHeight: '1em',
	margin: '0.5em 0 0.5em 0',
	padding: '0 4px',
	textAlign: 'center',
	...maxTextLines(2)
});


